import { render } from "./TopBarComponent.vue?vue&type=template&id=064a7556"
import script from "./TopBarComponent.vue?vue&type=script&lang=js"
export * from "./TopBarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/mohsen-ampd-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__